import agent, { ListData } from "../api/agent";
import { DataTableList } from "../common/interfaces/TableData";
import { Participant } from "../models/participant";
import { ParticipantFilter } from "../models/participantFilter";
import { FilterProps } from "../common/DataTable";

export type ParticipantStore = {
  tableData: DataTableList<Participant>;
  loading: boolean;

  loadParticipants: (activityId: string, filterProps?: FilterProps) => Promise<ListData<Participant> | void>;
  searchParticipant: (query: string) => Promise<ParticipantFilter[]>;
  createParticipant: (data: { id: string; activityId: string }) => Promise<void>;
  deleteParticipant: (id: string) => Promise<void>;
};

export const createParticipantStore = (set: any, _get: any): ParticipantStore => ({
  tableData: new DataTableList<Participant>(),
  loading: false,

  loadParticipants: async (activityId: string, filterProps?: FilterProps) => {
    set((s: any) => ({ participantStore: { ...s.participantStore, loading: true } }));
    try {
      const res: ListData<Participant> = await agent.Participants.list(activityId, filterProps);
      const list = res.data.reduce((acc: Map<string, Participant>, item: Participant) => {
        acc.set(item.id!, item);
        return acc;
      }, new Map<string, Participant>());
      set((s: any) => ({
        participantStore: {
          ...s.participantStore,
          tableData: {
            list,
            currentPage: res.currentPage,
            pageSize: res.pageSize,
            totalRecords: res.totalRecords,
            orderBy: res.orderBy,
          },
          loading: false,
        },
      }));
      return res;
    } catch (e) {
      console.error(e);
      set((s: any) => ({ participantStore: { ...s.participantStore, loading: false } }));
    }
  },

  searchParticipant: async (query: string) => {
    const res = await agent.Participants.search(query);
    return res || [];
  },

  createParticipant: async (data: { id: string; activityId: string }) => {
    await agent.Participants.create(data);
  },

  deleteParticipant: async (id: string) => {
    await agent.Participants.delete(id);
  },
});